import amb from 'amb-client-js';
window.__TECTONIC__amb_client_js = amb;
window.amb = amb;
export default amb;